import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding-block: 0;
`;

export const InnerContentWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding-bottom: 1rem;
  }
`;

export const FooterActionWrapper = styled.div`
  margin-top: 1.875rem;

  @media only screen and (max-width: 768px) {
    margin: 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  margin-top: 2rem;

  @media only screen and (max-width: 768px) {
    margin-top: 1.25rem;
    flex-direction: column;
  }
`;

export const BlockInner = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex-grow: 1;
  row-gap: 1rem;
  position: relative;
  padding-bottom: 1rem;

  &:before {
    position: absolute;
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    content: '';
    pointer-events: none;
    border-bottom: 1px solid #edeced;
  }
`;

export const StickyHolder = styled.div`
  width: 25%;
  margin-bottom: 0.875rem;

  @media only screen and (max-width: 1070px) {
    width: 30%;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const NewsHolder = styled.div`
  width: 75%;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const InformativeHolder = styled.div`
  gap: 2rem;
`;

export const MostReadWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const SubMenu = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding-top: 5px;
  border-top: 1px solid #28282820;
`;

export const MenuItem = styled.div`
  flex: 0 0 100%;
  font-weight: 900;
  font-size: 14px;
  padding: 7px 0;
  display: flex;
  justify-content: space-between;
`;
